import {FarmType} from '@/common/Enum/FarmType.Enum';
import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoaderService} from '@services/loader.service';
import {UserService} from '@services/user.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-update-profile',
    templateUrl: './update-profile.component.html',
    styleUrl: './update-profile.component.scss'
})
export class UpdateProfileComponent {
    accountForm: FormGroup;
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    farmTypes: {value: number; name: string}[] = [];
    isEditing = {
        name: false,
        phone: false,
        email: false,
        password: false,
        title: false
    };
    userDetail: any;
    userId = 1; // Assume userId is known or retrieved via route params, login, etc.

    constructor(
        private fb: FormBuilder,
        private accountService: UserService,
        private loaderService: LoaderService,
        private toastr: ToastrService
    ) {
        // Initialize the form with form controls and validators
    }

    ngOnInit(): void {
        this.farmTypes = this.getFarmTypes();
        this.accountForm = this.fb.group({
            id: [0],
            name: ['', Validators.required],
            phone: [
                '',
                [Validators.required, Validators.pattern('^[0-9]{10}$')]
            ],
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )
                ]
            ],
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(
                        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z0-9]).{8,}$'
                    )
                ]
            ],
            title: ['']
        });
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.getUserInformation();
    }
    filterPhoneInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        // Replace any non-digit characters with an empty string
        input.value = input.value.replace(/[^0-9]/g, '');
        // Update the form control with the cleaned value
        this.accountForm.get('phone')?.setValue(input.value);
    }
    // Fetch user information by userId
    getUserInformation(): void {
        this.accountService
            .getUserProfileById(this.userDetail.id)
            .subscribe((result) => {
                // Populate the form with user data
                this.accountForm.patchValue(result);
            });
    }

    // Toggle edit mode for a field
    toggleEdit(field: string): void {
        this.isEditing[field] = !this.isEditing[field];
    }
    getFarmTypes(): {value: number; name: string}[] {
        return Object.keys(FarmType)
            .filter((key) => isNaN(Number(key))) // Filter out numeric keys
            .map((key) => ({
                value: FarmType[key as keyof typeof FarmType],
                name: key
            }));
    }
    // Save updates
    saveUpdates(): void {
        if (
            !this.accountForm.get('name')?.valid ||
            !this.accountForm.get('phone')?.valid ||
            !this.accountForm.get('email')?.valid
        ) {
            this.toastr.error('Please fill in all required fields correctly.');
            return; // Stop the execution if the form is invalid
        }
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        const payload = {
            ...this.accountForm.value,
            phone: String(this.accountForm.value.phone) // Convert to string explicitly
        };
        this.accountService.updateUserProfile(payload).subscribe({
            next: (response: any) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.success('Profile Updated Successfully');
                }, 2000);
            },
            error: (error) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    // Handle login error
                    this.toastr.error('Profile not Updated');
                }, 2000);
            }
        });
    }
}
